import * as React from "react";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import TextInput from "../../../../Layout/Inputs/TextInput";

export function BidpackInput({
  ltlPipeline,
}: {
  ltlPipeline: LtlPipelineViewModel;
}) {
  const bidpackValue = ltlPipeline?.LtlBidpack?.Name ?? "";

  return <TextInput label="LTL Bidpack" value={bidpackValue} disabled />;
}
